import React, { createRef } from 'react'
import { Header, Menu, Popup, Label, Table, Ref, Icon, List, Modal, Container } from 'semantic-ui-react'
import parse from 'html-react-parser';
const data = ["code 1", "code 2", "code 3", "code 4", "code 5"];

const openInNewTab = (url) => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
  if (newWindow) newWindow.opener = null
}

const propagationWrapper = (e, code, text, getID) => {
  e.stopPropagation()
  getID(code, text)
}

const filterPropWrapper = (e, code, text, setCellRef, cellRef) => {
  e.stopPropagation()
  e.preventDefault()
  setCellRef(code, text, cellRef)
}

const Cell = (items, lookup, getID, setCellRef) => {
  let createdCells = []
  const cellRefs = React.useRef([])

  if (cellRefs.current.length !== items.length) {
    // add or remove refs
    cellRefs.current = Array(items.length).fill().map((_, i) => cellRefs.current[i] || createRef())
  }

  for (const [idx, code] of items.entries()) {
    let isprotein = lookup[code].hasOwnProperty('aliases')
    if (typeof (code) === 'number') {
      createdCells.push(
        <Ref innerRef={cellRefs.current[idx]}>
          <Label
            as="a"
            onClick={(e) => {
              e.stopPropagation()
              openInNewTab(lookup[code.toString()].kegg)
            }}
            onContextMenu={(e) => filterPropWrapper(e, code, lookup[code].text, setCellRef, cellRefs.current[idx])}
            style={{ padding: "5px", margin: "2px" }}>
            <div style={{ lineHeight: "1.25em" }}>
              <Icon name="th list" />
              {lookup[code.toString()].text}
            </div>
          </Label>
        </Ref>)
    } else {
      createdCells.push(
        <Popup key={idx.toString()} mouseEnterDelay={500}
          hoverable basic wide on={["hover"]} position="top left"
          trigger={
            <Ref innerRef={cellRefs.current[idx]}
              onClick={isprotein ? (e) => propagationWrapper(e, lookup[code].code, lookup[code].text, getID) : null}>
              <Label
                onContextMenu={(e) => filterPropWrapper(e, lookup[code].code, lookup[code].text, setCellRef, cellRefs.current[idx])}
                key={idx.toString()} as={isprotein ? "a" : null}
                style={isprotein ? { padding: "5px", margin: "2px" } :
                  {
                    padding: "5px", margin: "2px", color: "rgba(0,0,0,0.8)",
                    background: "transparent", borderRadius: "0px", border: "solid 1px rgba(0,0,0,0.8)"
                  }}>
                {lookup[code].text}
              </Label>
            </Ref>
          }>
          <Header>{"Also known as:"}</Header>
          <p>{isprotein ? lookup[code].aliases.join(", ") : lookup[code].desc}</p>
        </Popup>)
    }
  }
  return createdCells
}

const outputCell = (items, lookup, getID, setCellRef) => {
  let createdSections = []
  const cellRefs = React.useRef([])
  const contRefs = React.useRef([])
  if (cellRefs.current.length !== items[1].length) {
    // add or remove refs
    cellRefs.current = Array(items[1].length).fill().map((_, i) => cellRefs.current[i] || createRef())
  }
  if (contRefs.current.length !== Object.keys(items[0]).length) {
    // add or remove refs
    contRefs.current = Array(Object.keys(items[0]).length).fill().map((_, i) => contRefs.current[i] || [])
  }
  //console.log(contRefs)
  for (const [idx, entity] of items[1].entries()) {
    createdSections.push(
      <Popup key={"1_" + idx.toString()} mouseEnterDelay={500}
        hoverable basic wide on={['hover']} position="top left"
        trigger={
          <Ref innerRef={cellRefs.current[idx]}>
            <Label
              onContextMenu={(e) => filterPropWrapper(e, lookup[entity].code, lookup[entity].text, setCellRef, cellRefs.current[idx])}
              style={{
                padding: "5px", margin: "2px", color: "rgba(0,0,0,0.8)",
                background: "transparent", borderRadius: "0px", border: "solid 1px rgba(0,0,0,0.8)"
              }}>
              {lookup[entity].text}
            </Label>
          </Ref>
        }>
        <Header>{"Also known as:"}</Header>
        <p>{lookup[entity].desc}</p>
      </Popup>
    )
  }
  for (const [idx, key] of Object.keys(items[0]).entries()) {
    let createdLabels = []
    contRefs.current[idx] = Array(items[0][key].length).fill().map((_, i) => contRefs.current[idx][i] || createRef())
    for (const [j, code] of items[0][key].entries()) {
      let isprotein = lookup[code].hasOwnProperty('aliases')
      createdLabels.push(
        <Popup key={j.toString()} mouseEnterDelay={500}
          hoverable basic wide on={['hover']} position="top left"
          trigger={
            <Ref onClick={isprotein ? (e) => propagationWrapper(e, lookup[code].code, lookup[code].text, getID) : null}
              innerRef={contRefs.current[idx][j]}>
              <Label
                onContextMenu={(e) => filterPropWrapper(e, lookup[code].code, lookup[code].text, setCellRef, contRefs.current[idx][j])}
                as={isprotein ? "a" : null}
                style={isprotein ? { padding: "5px", margin: "2px" } :
                  {
                    padding: "5px", margin: "2px", color: "rgba(0,0,0,0.8)",
                    background: "transparent", borderRadius: "0px", border: "solid 1px rgba(0,0,0,0.8)"
                  }}>
                {lookup[code].text}
              </Label>
            </Ref>
          }>
          <Header>{"Also known as:"}</Header>
          <p>{isprotein ? lookup[code].aliases.join(", ") : lookup[code].desc}</p>
        </Popup>
      )
    }
    createdSections.push(<div key={idx.toString()} style={{
      borderLeft: "solid 0.5px",
      borderColor: "rgba(0,0,0,0.4)", borderRadius: "0px"
    }}>
      <Container style={{ paddingLeft: "4px" }} textAlign='left'>
        <p style={{ padding: "2px", fontSize: "13px", fontWeight: "600", margin: "0px" }}>{key}</p>
        {createdLabels}</Container></div>)
  }
  return createdSections
}

const Row = (props) => {
  const rowRef = React.useRef(null)

  const contextWrapper = (e) => {
    props.setRowRef(rowRef, props.rowData)
    props.openCitations()
  }

  return (
    <React.Fragment>
      <Ref innerRef={rowRef}>
        <Table.Row onClick={contextWrapper}
          style={props.border ? {
            display: "table", width: "100%", tableLayout: "fixed",
            borderBottom: "solid", borderBottomColor: "#dededf",
            borderBottomWidth: "1px"
          } :
            { display: "table", width: "100%", tableLayout: "fixed" }}>
          <Table.Cell style={{ width: "17.5%" }} >
            {Cell(props.rowData['input'], props.rowData['lookup'], props.getID, props.setCellRef)}
          </Table.Cell>
          <Table.Cell style={{ width: "17.5%" }} >
            {Cell(props.rowData['sensor'], props.rowData['lookup'], props.getID, props.setCellRef)}
          </Table.Cell>
          <Table.Cell style={{ width: "26.25%" }}>
            {Cell(props.rowData['circuit_code'], props.rowData['lookup'], props.getID, props.setCellRef)}
          </Table.Cell>
          <Table.Cell style={{ width: "38.75%" }}>
            {outputCell(props.rowData['output'], props.rowData['lookup'], props.getID, props.setCellRef)}
          </Table.Cell>
        </Table.Row>
      </Ref>
    </React.Fragment>)
};

class MainTable extends React.Component {
  constructor(props) {
    super(props);
    this.data = data;
    this.state = {
      overflowed: false,
      openRowPopup: false,
      openCellPopup: false,
      curfocus: null,
      rowRef: null,
      cellRef: null,
      openCitation: false,
      citedRow: null
    };
    this.element = createRef();
    this.generateRows = this.generateRows.bind(this);
    this.setRowRef = this.setRowRef.bind(this);
    this.setCellRef = this.setCellRef.bind(this);
  }

  queryFocus = () => {
    this.setState({ openCellPopup: false })
    this.props.setFocus({
      code: this.state.curfocus.code,
      text: this.state.curfocus.text
    })
  }

  setCellRef = (code, text, cellRef) => {
    this.setState({
      curfocus: {
        code: code,
        text: text
      },
      cellRef: cellRef,
      openCellPopup: true,
      openRowPopup: false
    })
  }

  cellPopupClose = () => { this.setState({ openCellPopup: false }) }

  openCitations = () => {
    this.setState({
      openCitation: true,
      openRowPopup: false
    })
  }
  closeCitations = () => { this.setState({ openCitation: false }) }

  rowPopupClose = () => { this.setState({ openRowPopup: false }) }

  setRowRef = (ref, rowData) => {
    this.setState({
      rowRef: ref,
      openRowPopup: true,
      openCellPopup: false,
      citedRow: rowData
    })
  }

  generateRows = (rows) => {
    let createdRows = [];
    for (const [idx, rowData] of rows.entries()) {
      if (idx === (rows.length - 1)) {
        createdRows.push(
          <Row rowData={rowData} border={true} getID={this.props.getID} openCitations={this.openCitations}
            setRowRef={this.setRowRef} setCellRef={this.setCellRef} key={idx.toString()} />
        )
      }
      else {
        createdRows.push(
          <Row rowData={rowData} border={false} getID={this.props.getID} openCitations={this.openCitations}
            setRowRef={this.setRowRef} setCellRef={this.setCellRef} key={idx.toString()} />
        );
      }
    }
    return createdRows;
  };

  componentDidMount() {
    const element = this.element;
    console.log(element.current.offsetHeight < element.current.scrollHeight)
    if (element.current.offsetHeight < element.current.scrollHeight) {
      this.setState({ overflowed: true })
    }
  }

  renderReferences = () => {
    let allRefs = []
    let refs = this.state.citedRow['refs']
    for (const [idx, ref] of refs.entries()) {
      allRefs.push(<List.Item style={{ padding: "2px" }} key={idx.toString()}> {parse(ref)}</List.Item>)
    }
    console.log(refs)
    return (<List bulleted >
      {allRefs}
    </List>)
  }

  render() {
    let createdRows = this.generateRows(this.props.rows);
    let offsetTop = this.element.current ? this.element.current.getBoundingClientRect().top + 15 : null;
    let tableheight = offsetTop ? this.props.windowHeight - offsetTop + "px" : "auto";
    return (
      <React.Fragment>
        <Modal size={'small'} closeOnEscape={true} closeOnDimmerClick={true}
          open={this.state.openCitation} onClose={this.closeCitations}>
          <Modal.Header style={{ fontSize: "large", fontWeight: 600, fontFamily: "Lato" }}>
            References</Modal.Header>
          <Modal.Content>
            <span style={{ paddingBottom: "4px" }}>This record was compiled based on the following work:</span>
            {this.state.citedRow == null ? null : this.renderReferences()}
          </Modal.Content>
        </Modal>
        {/*<Popup context = {this.state.rowRef} onClose={this.rowPopupClose} open={this.state.openRowPopup}
              position = {"top center"}>
          <Menu secondary vertical>
            <Menu.Item
              name = "citations" content = "View citations" icon = "file alternate"
              onClick = {this.openCitations}
            />
          </Menu>
    </Popup>*/}
        <Popup context={this.state.cellRef} onClose={this.cellPopupClose} open={this.state.openCellPopup}
          position={"bottom center"} style={{ height: "46px" }}>
          <Menu secondary vertical style={{ width: "6rem" }}>
            <Menu.Item style={{
              margin: "0px", width: "6rem",
              paddingTop: "4px", paddingBottom: "4px", paddingLeft: "6px", paddingRight: "6px"
            }}
              name="focus" content="Focus" icon="filter"
              onClick={this.queryFocus}
            />
          </Menu>
        </Popup>
        <Table striped selectable padded>
          <Table.Header style={this.state.overflowed ? { display: "table", width: "100%", paddingRight: "10px", backgroundColor: "#F9FAFB", tableLayout: "fixed" }
            : { display: "table", width: "100%", backgroundColor: "#F9FAFB", tableLayout: "fixed" }}>
            <Table.Row>
              <Table.HeaderCell style={{ width: "17.5%" }} id="norpad" singleLine> <p id="border">Input</p></Table.HeaderCell>
              <Table.HeaderCell style={{ width: "17.5%" }} id="norpad"> <p id="border">Sensor</p></Table.HeaderCell>
              <Table.HeaderCell style={{ width: "26.25%" }} id="norpad"><p id="border">Cascade</p></Table.HeaderCell>
              <Table.HeaderCell style={{ width: "38.75%" }}>Output</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Ref innerRef={this.element}>
            <Table.Body style={{ display: "block", height: tableheight, overflow: "auto" }}>{createdRows}</Table.Body>
          </Ref>
        </Table>
      </React.Fragment>
    );
  }
}

export default MainTable;



// WEBPACK FOOTER //
// ./src/components/table.jsx